/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/final.glb 
*/

import React, { useEffect, useRef, useState } from 'react'
import { Environment, useGLTF, useTexture } from '@react-three/drei'
import * as THREE from 'three'

export function WallAcrylic({ image, frameSize = { width: 12, height: 12 }, thickness = 1, screws = true, wallColor = "#009900", ...props }) {
  const { nodes, materials } = useGLTF('/3d/acralic.glb')
  const [screw, setScrews] = useState(screws)

  const texture = useTexture(image)
  const materialRef = useRef();

  const [aspectX, aspectY] = [frameSize.width, frameSize.height];
  const baseSize = 1.5;
  const scaleX = (aspectX / Math.max(aspectX, aspectY)) * baseSize;
  const scaleY = (aspectY / Math.max(aspectX, aspectY)) * baseSize;

  useEffect(() => {
    if (materialRef.current) {
      materialRef.current.uniforms.uTexture.value = texture;
    }

  }, [texture]);

  return (
    <>
      <Environment files='/3d/gainmap.jpg' />
      <group receiveShadow castShadow {...props} dispose={null} position={[0, 0.25, 0]} rotation={[0.0, 0, 0]}>
        <group name='frame' scale={[1, 1, 1]}>
          <group receiveShadow castShadow scale={[scaleX, scaleY, thickness]}>
            <mesh receiveShadow castShadow geometry={nodes.Cube001.geometry} material={nodes.Cube001.material} position={[0.461, 0.41, 0.028]} rotation={[0, -1.571, 0]} scale={[0.01, 0.5, 0.5]} >
              <meshPhysicalMaterial
                color="white"
                transparent={true}
                opacity={0.6}
                roughness={0.1}
                reflectivity={0.1}
                metalness={.9}
                transmission={1.0}
                thickness={0.5}
                ior={1.5}
                envMapIntensity={0.75}
              />
            </mesh>
            {screw ?
              <group name='screws'>
                <mesh receiveShadow castShadow geometry={nodes.Circle.geometry} material={nodes.Circle.material} position={[0.046, 0.826, 0.036]} rotation={[Math.PI / 2, -Math.PI / 2, 0]} scale={0.03} >
                  <meshStandardMaterial metalness={1.0} roughness={0.3} color='white' />
                </mesh>
                <mesh receiveShadow castShadow geometry={nodes.Circle001.geometry} material={nodes.Circle001.material} position={[0.876, 0.826, 0.036]} rotation={[Math.PI / 2, -Math.PI / 2, 0]} scale={0.03} >
                  <meshStandardMaterial metalness={1.0} roughness={0.3} color='white' />
                </mesh>
                <mesh receiveShadow castShadow geometry={nodes.Circle002.geometry} material={nodes.Circle002.material} position={[0.046, -0.005, 0.036]} rotation={[Math.PI / 2, -Math.PI / 2, 0]} scale={0.03} >
                  <meshStandardMaterial metalness={1.0} roughness={0.3} color='white' />
                </mesh>
                <mesh receiveShadow castShadow geometry={nodes.Circle003.geometry} material={nodes.Circle003.material} position={[0.876, -0.005, 0.036]} rotation={[Math.PI / 2, -Math.PI / 2, 0]} scale={0.03} >
                  <meshStandardMaterial metalness={1.0} roughness={0.3} color='white' />
                </mesh>
              </group> : null
            }
            <mesh receiveShadow castShadow geometry={nodes.Plane001.geometry} material={nodes.Plane001.material} position={[0.461, 0.41, 0.038]} rotation={[Math.PI / 2, -Math.PI, 0]} scale={[0.5, 1, 0.5]} >
              <meshBasicMaterial map={texture} side={THREE.DoubleSide} />
            </mesh>

            <mesh receiveShadow castShadow geometry={nodes.Plane002.geometry} material={nodes.Plane002.material} position={[0.461, 0.41, 0.042]} rotation={[Math.PI / 2, -Math.PI / 2, 0]} scale={[0.5, 1, 0.5]} >
              <meshPhysicalMaterial
                color="white"
                transparent={true}
                opacity={0.3}
                roughness={0.1}
                reflectivity={0.1}
                metalness={.9}
                transmission={1.0}
                thickness={0.5}
                ior={1.5}

                envMapIntensity={1}
              />
            </mesh>
          </group>
        </group>


        <group name='wall' receiveShadow castShadow scale={[1.75, 1, 1]}>
          <mesh receiveShadow castShadow geometry={nodes.Plane.geometry} material={nodes.Plane.material} position={[0.5, 0, 0]} rotation={[Math.PI / 2, 0, 0]} scale={[1.519, 2, 2]} >
            <meshStandardMaterial color={'white'} side={THREE.DoubleSide} />
          </mesh>
          <mesh receiveShadow castShadow geometry={nodes.Plane007.geometry} material={nodes.Plane007.material} position={[0.5, 0, 0]} rotation={[Math.PI / 2, 0, 0]} scale={[1.519, 2, 2]} >
            <meshStandardMaterial color={'green'} side={THREE.DoubleSide} />
          </mesh>
        </group>
        <group receiveShadow castShadow position={[-.95, 0, 0.1]}>
          <mesh receiveShadow castShadow geometry={nodes.bookshelf_1.geometry} material={nodes.bookshelf_1.material} position={[-1.542, -1.982, 0.44]} scale={1.64} >
            <meshStandardMaterial color={'green'} side={THREE.DoubleSide} />
          </mesh>
          <mesh receiveShadow castShadow geometry={nodes.Object_6.geometry} material={nodes.Object_6.material} position={[-1.399, -0.265, 0.514]} rotation={[0, -0.101, 0]} scale={0.172} >
            <meshStandardMaterial color={'red'} side={THREE.DoubleSide} />
          </mesh>
          <group receiveShadow castShadow position={[-1.393, -0.131, 0.51]} rotation={[3.13, 0.229, -3.006]} scale={0.172}>
            <mesh receiveShadow castShadow geometry={nodes.Object_6_1.geometry} material={materials.plant_rim} />
            <mesh receiveShadow castShadow geometry={nodes.Object_6_2.geometry} material={materials.plant} />
          </group>
          <mesh receiveShadow castShadow geometry={nodes.Cup.geometry} material={materials['Material.002']} position={[-1.399, -1.408, 0.467]} scale={0.123} >
            <meshStandardMaterial color={'red'} side={THREE.DoubleSide} />
          </mesh>
          <mesh receiveShadow castShadow geometry={nodes.Book_003_M_Books_0.geometry} material={materials.M_Books} position={[-1.663, -0.795, 0.456]} rotation={[-1.607, -0.349, -1.578]} scale={0.194} />
          <mesh receiveShadow castShadow geometry={nodes.Book_004_M_Books_0.geometry} material={materials.M_Books} position={[-1.602, -0.793, 0.461]} rotation={[-1.608, -0.453, -1.582]} scale={0.194} />
          <mesh geometry={nodes.Book_005_M_Books_0.geometry} material={materials.M_Books} position={[-1.702, -0.793, 0.459]} rotation={[-1.606, -0.324, -1.577]} scale={[0.194, 0.251, 0.201]} />
          <mesh receiveShadow castShadow geometry={nodes.Book_006_M_Books_0.geometry} material={materials.M_Books} position={[-1.762, -0.787, 0.445]} rotation={[-1.605, -0.222, 1.568]} scale={[0.194, 0.319, 0.202]} />
          <mesh receiveShadow castShadow geometry={nodes.vase_vase009.geometry} material={materials.vase} position={[-1.671, 0.32, 0.455]} rotation={[Math.PI / 2, 0, 0]} scale={0.381} >
            <meshStandardMaterial color={'red'} side={THREE.DoubleSide} />
          </mesh>
        </group>
      </group>
    </>
  )
}

useGLTF.preload('/3d/acralic.glb')
